import { render } from "./SpaceFormPageThree.vue?vue&type=template&id=7ce1899a"
import script from "./SpaceFormPageThree.vue?vue&type=script&lang=js"
export * from "./SpaceFormPageThree.vue?vue&type=script&lang=js"
script.render = render

export default script